export default __webpack_public_path__ + "static/media/Header_logo.8f2ddc47.png";